import { ArrowLeft } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { usePremisesStore } from "../../store/store";
import axiosInstance from "../../common/axiosInstance";

const Allmodules: React.FC = () => {
  const { id } = useParams<{ id: any }>();
  const navigate = useNavigate();
  const [checkedItems, setCheckedItems] = useState<string[]>([]);
  const location = useLocation();
  const path = location.pathname.split("/");
  const isView = path[1] === "view-premises" ? true : false;
  const { setAllModules } = usePremisesStore();
  const allModules = [
    "Tasks",
    "Policies & Manuals",
    "Risk Assessment & mitigation Plan",
    "Budgeting For Fire Safety Systems",
    "Fire Safety Equipment Inventory & Maintenance",
    "Staff training & Evaluation",
    "Testing/Drills",
    "Monitoring",
    "Fire Safety Audits",
    "Complaint/Ticketing/Incidents",
    "Data Monitoring & Analysis",
  ];
  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setCheckedItems(allModules);
      setAllModules(checkedItems);
    } else {
      setCheckedItems([]);
    }
  };
  useEffect(() => {
    const getPremisesById = async () => {
      const response: any = await axiosInstance.get(`/api/premises/${id}`);
      setCheckedItems(response.data.modules);
    };
    if (id) {
      getPremisesById();
    }
  }, [id]);

  const submitModules = (e: React.FormEvent) => {
    setAllModules(checkedItems);
    navigate(
      isView === true
        ? `/view-premises/modules/premises-modules/${id}`
        : id
        ? `/update-premises/modules/premises-modules/${id}`
        : "/add-premises/modules/premises-modules/"
    );
  };

  const handleCheckboxChange = (item: string) => {
    setCheckedItems((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );

    setAllModules(checkedItems);
  };
  return (
    <>
      <div className="flex w-full  mt-16 flex-col mb-2 justify-start  px-3 items-start ">
        <div className=" w-full flex justify-between items-center  mr-4  pb-2">
          <h1>
            {isView === true
              ? "View Premises"
              : id
              ? "Update Premises"
              : "Add Premises"}
          </h1>
          <div className="flex w-1/2 items-center justify-between">
            <span>
              Admin: <strong>Bhanu prasad</strong>
            </span>
            <div>
              <span>
                Create Date: <strong>09/01-2025</strong>
              </span>
            </div>
            <div>
              <Link to="/premises" data-discover="true">
                <button className="flex items-center px-3 py-2 bg-[#61748e] text-white rounded-full">
                  <ArrowLeft />
                  Back
                </button>
              </Link>
            </div>
          </div>
        </div>
        <div className="w-[98%] bg-gray-200 rounded-full h-2.5 mx-2">
          <div
            className="bg-[#0fa9a6] h-2.5 rounded-full"
            style={{ width: `50%` }}
          ></div>
        </div>
        <div className="w-full h-full pt-4 drop-shadow-lg mr-4 rounded-t-lg bg-white flex-col">
          <form className="w-full px-4 h-[350px]">
            <div className="flex items-center bg-[#f0f8ff]  px-4 py-2 font-semibold">
              <input
                onChange={handleSelectAll}
                checked={checkedItems.length === allModules.length}
                type="checkbox"
                className="mr-2"
                disabled={isView === true}
                name="select"
                id=""
              />
              <span className="text-2xl">Select All Modules</span>
            </div>

            <div className="flex items-center ml-3 my-3 font-semibold">
              <h5 className="text-1xl font-semibold">Select Modules</h5>
            </div>

            <div className="grid grid-rows-3 grid-cols-3  gap-5 ">
              {allModules.map((module, index) => (
                <div key={index} className="flex ml-4 items-center">
                  <input
                    checked={checkedItems.includes(module)}
                    onChange={() => handleCheckboxChange(module)}
                    type="checkbox"
                    disabled={isView === true}
                    className="text-2xl mr-2"
                  />
                  <label className="text-[15px] m-0 font-semibold">
                    {module}
                  </label>
                </div>
              ))}
            </div>
          </form>

          <div className="w-full mt-7 flex justify-end items-center h-18 p-2 bg-[#61748e]">
            <Link
              className="text-white mr-2"
              to={
                isView === true
                  ? `/view-premises/${id}`
                  : id
                  ? `/update-premises/${id}`
                  : "/add-premises/"
              }
              data-discover="true"
            >
              <button className="h-10 bg-[#869ab6] text-lg px-5 py-1 rounded-full bottom-0 left-0 right-0">
                Previous
              </button>
            </Link>

            <button
              onClick={(e) => submitModules(e)}
              className="h-10 bg-[#0fa9a6] text-white text-lg px-5 py-1 rounded-full bottom-0 left-0 right-0"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Allmodules;
